import { render, staticRenderFns } from "./UserEditSecurityDetails.vue?vue&type=template&id=96864258&"
import script from "./UserEditSecurityDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditSecurityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96864258')) {
      api.createRecord('96864258', component.options)
    } else {
      api.reload('96864258', component.options)
    }
    module.hot.accept("./UserEditSecurityDetails.vue?vue&type=template&id=96864258&", function () {
      api.rerender('96864258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/users/views/UserEditSecurityDetails.vue"
export default component.exports